import axios from '@/utils/api'

const actions = {

  async findTiposDocumento ({ commit }, url) {
    const result = await axios({
      url: `publico/tipoDocumento/${url}`,
      method: 'GET'
    })

    return result
  }

}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/centralInteressado/tipoDocumento.js